var exports = {
  "j": "OverlaysTab.module__buttonsWrapper___TTlsMF",
  "F": "OverlaysTab.module__demoArea___TTlsMF",
};

module.exports = exports;
